// constants
import { EncounterActionTypes } from './constants';
import {
    Encounter as EncounterDataType,
    EncounterDetail,
    EncounterAddress,
    Discount as DiscountInterface,
    EncounterTest,
} from 'src/types/encounter';

export type EncounterActionType = {
    type:
        | EncounterActionTypes.API_RESPONSE_SUCCESS
        | EncounterActionTypes.API_RESPONSE_ERROR
        | EncounterActionTypes.GET_ENCOUNTER
        | EncounterActionTypes.ADD_ENCOUNTER
        | EncounterActionTypes.EDIT_ENCOUNTER
        | EncounterActionTypes.GET_ENCOUNTERS
        | EncounterActionTypes.GET_PATIENT_ENCOUNTERS
        | EncounterActionTypes.GET_ENCOUNTER_ADDRESS_INFO
        | EncounterActionTypes.GET_DISCOUNT
        | EncounterActionTypes.ADD_ENCOUNTER_TEST
        | EncounterActionTypes.UPDATE_ENCOUNTER_TEST_DATA
        | EncounterActionTypes.GET_ENCOUNTER_TEST_DATA
        | EncounterActionTypes.RESET
        | EncounterActionTypes.RESET_SUCCESS
        | EncounterActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const encounterApiResponseSuccess = (
    actionType: string,
    data:
        | EncounterDataType[]
        | EncounterDataType
        | EncounterDetail
        | EncounterAddress
        | DiscountInterface
        | EncounterTest
        | []
        | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): EncounterActionType => ({
    type: EncounterActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const encounterApiResponseError = (
    actionType: string,
    data:
        | EncounterDataType[]
        | EncounterDataType
        | EncounterDetail
        | EncounterAddress
        | DiscountInterface
        | EncounterTest
        | []
        | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): EncounterActionType => ({
    type: EncounterActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const addEncounter = (params: any): EncounterActionType => ({
    type: EncounterActionTypes.ADD_ENCOUNTER,
    payload: params,
});

export const editEncounter = (params: any): EncounterActionType => ({
    type: EncounterActionTypes.EDIT_ENCOUNTER,
    payload: params,
});

export const getEncounter = (params: any): EncounterActionType => ({
    type: EncounterActionTypes.GET_ENCOUNTER,
    payload: params,
});

export const getEncounters = (params: any): EncounterActionType => ({
    type: EncounterActionTypes.GET_ENCOUNTERS,
    payload: params,
});

export const getPatientEncounters = (params: any): EncounterActionType => ({
    type: EncounterActionTypes.GET_PATIENT_ENCOUNTERS,
    payload: params,
});

export const getDiscountValue = (params: any): EncounterActionType => ({
    type: EncounterActionTypes.GET_DISCOUNT,
    payload: params,
});

export const getEncounterAddress = (params: any): EncounterActionType => ({
    type: EncounterActionTypes.GET_ENCOUNTER_ADDRESS_INFO,
    payload: params,
});

export const getEncounterTestData = (params: any): EncounterActionType => ({
    type: EncounterActionTypes.GET_ENCOUNTER_TEST_DATA,
    payload: params,
});

export const addEncounterTest = (params: any): EncounterActionType => ({
    type: EncounterActionTypes.ADD_ENCOUNTER_TEST,
    payload: params,
});
export const updateEncounterTestData = (params: any): EncounterActionType => ({
    type: EncounterActionTypes.UPDATE_ENCOUNTER_TEST_DATA,
    payload: params,
});
export const resetEncounter = (): EncounterActionType => ({
    type: EncounterActionTypes.RESET,
    payload: {},
});

export const resetEncounterSuccess = (): EncounterActionType => ({
    type: EncounterActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetEncounterError = (): EncounterActionType => ({
    type: EncounterActionTypes.RESET_ERROR,
    payload: {},
});
